import axios from 'axios';

const API_BASE = '/api';

export const timeTrackingService = {
    // Create a new time entry with optional GitHub commit
    async createTimeEntry(taskId, timeEntryData) {
        try {
            const response = await axios.post(`${API_BASE}/tasks/${taskId}/time-entries`, timeEntryData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    // Get all time entries for a task
    async getTaskTimeEntries(taskId) {
        try {
            const response = await axios.get(`${API_BASE}/tasks/${taskId}/time-entries`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    // Get recent time entries with GitHub commits
    async getTimeEntriesWithCommits(limit = 50) {
        try {
            const response = await axios.get(`${API_BASE}/time-entries/with-commits?limit=${limit}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    // Create time entry from GitHub commit
    async createTimeEntryFromCommit(taskId, commitData, description, durationMinutes) {
        try {
            // Convert duration minutes to hours and remaining minutes
            const hours = Math.floor(durationMinutes / 60);
            const minutes = durationMinutes % 60;
            
            const timeEntryData = {
                task_id: taskId,
                hours: hours,
                minutes: minutes,
                description: description,
                github_commit: commitData
            };
            
            const response = await axios.post(`${API_BASE}/time-entries/manual`, timeEntryData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }
};
